import { useEffect, useState } from "react";
import LoginImage from "../assest/images/Bg_Login.jpg";
import { Link, useNavigate } from "react-router-dom";

import { toast } from "react-toastify";
import apiInstance from "../apiConfig/apiinstance";

function LoginPage({ prop }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false); // 👈 Added for toggle

  useEffect(() => {
    if (localStorage.getItem("token")) {
      navigate("/");
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();

    const payload = { email, password };
    setLoading(true);

    try {
      const { data } = await apiInstance.post(
        `/api/auth/v1/auth/login/`,
        payload
      );
      if (data.status === 200) {
        localStorage.setItem("token", data?.data?.tokens?.access);
        toast.success("Login Successful");
        if (localStorage.getItem("path")) {
          navigate(localStorage.getItem("path"));
        } else {
          navigate("/");
        }
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Error logging in");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100 relative">
      <img
        src={LoginImage}
        alt="login-bg"
        className="w-full h-full absolute top-0 left-0 object-cover opacity-50"
      />
      <form
        onSubmit={handleLogin}
        className="bg-white md:p-8 p-4 rounded shadow-md w-full m-2 z-10 md:text-2xl md:max-w-[35rem]"
      >
        <h2 className="text-2xl font-bold mb-6 text-center">Login</h2>

        {/* Email */}
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="w-full mb-4 p-3 border border-gray-300 rounded"
        />

        {/* Password with eye toggle */}
        <div className="relative mb-4">
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            value={password}
            style={{ fontFamily: "monospace" }}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="w-full p-3 border border-gray-300 rounded pr-10"
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute inset-y-0 right-3 flex items-center text-black bg-transparent"
          >
            {showPassword ? (
              // Eye open
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="transparent"
                viewBox="0 0 24 24"
                stroke="black"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                />
              </svg>
            ) : (
              // Eye closed
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="transparent"
                viewBox="0 0 24 24"
                stroke="black"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13.875 18.825A10.05 10.05 0 0112 19c-4.477 0-8.268-2.943-9.542-7a10.05 10.05 0 011.658-3.03M6.343 6.343A9.955 9.955 0 0112 5c4.477 0 8.268 2.943 9.542 7a9.965 9.965 0 01-4.137 5.011M15 12a3 3 0 00-3-3m0 0a3 3 0 00-3 3m6 0a3 3 0 01-3 3m-3-3a3 3 0 013-3"
                />
              </svg>
            )}
          </button>
        </div>

        {/* Login button */}
        <button
          type="submit"
          disabled={loading}
          className="w-full bg-blue-600 text-white py-3 rounded hover:bg-blue-700 transition disabled:bg-gray-400"
        >
          Login
        </button>

        {/* Links */}
        <p className="text-center mt-4 text-gray-600">
          Forgot your password?{" "}
          <Link to="/forgot-password" className="text-blue-600 hover:underline">
            Forgot Password
          </Link>
        </p>
        <p className="text-center text-gray-600">
          <Link
            to="/auth/reset-password/"
            className="text-blue-600 hover:underline"
          >
            First time password setup
          </Link>
        </p>
      </form>
    </div>
  );
}

export default LoginPage;
